import React, { useEffect, useState } from "react";
import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
import { getGalleryInner } from "../Service/Api";

function PhotoGallery() {
  const [galleryData, setGalleryData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [years, setYears] = useState([]);

  const API_URL = "https://webapi.entab.info";

  const FALLBACK_IMAGE =
    "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/images/dummy.jpg";

  const DUMMY_IMAGE =
    "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/dummy.jpg";

  // ==============================
  // Fetch Gallery Data
  // ==============================
  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const data = await getGalleryInner();

        const gallery = Array.isArray(data) ? data : [];

        setGalleryData(gallery);

        // Get unique years
        const uniqueYears = [
          ...new Set(
            gallery
              .filter((item) => item.date)
              .map((item) => new Date(item.date).getFullYear()),
          ),
        ].sort((a, b) => b - a);

        setYears(uniqueYears);

        // Select latest year by default
        if (uniqueYears.length > 0) {
          setSelectedYear(uniqueYears[0]);
        }
      } catch (error) {
        console.error("Error fetching gallery data:", error);
        setGalleryData([]);
      }
    };

    fetchGallery();
  }, []);

  // ==============================
  // Filter Gallery Data
  // ==============================
  const filteredData = galleryData.filter((item) => {
    const itemDate = new Date(item.date);

    const itemYear = itemDate.getFullYear();
    const itemMonth = itemDate.getMonth() + 1;

    const title = item.title || "";

    const matchesCategory = item.category === "PhotoGallery";

    const matchesYear =
      selectedYear === "All" || itemYear === Number(selectedYear);

    const matchesMonth =
      selectedMonth === 0 || itemMonth === Number(selectedMonth);

    const matchesSearch = title
      .toLowerCase()
      .includes(searchText.toLowerCase().trim());

    return matchesCategory && matchesYear && matchesMonth && matchesSearch;
  });

  // ==============================
  // Format Date
  // ==============================
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    return {
      day: date.getDate(),
      month: date.toLocaleString("en-US", {
        month: "short",
      }),
    };
  };

  // ==============================
  // Show More
  // ==============================
  const handleShowMore = () => {
    const hiddenItems = document.querySelectorAll(".gallery-item.hidden");

    for (let i = 0; i < 8 && i < hiddenItems.length; i++) {
      hiddenItems[i].classList.remove("hidden");
    }

    const remainingItems = document.querySelectorAll(".gallery-item.hidden");

    if (remainingItems.length === 0) {
      const button = document.getElementById("showMoreBtn");

      if (button) {
        button.style.display = "none";
      }
    }
  };

  // ==============================
  // Reset Filters
  // ==============================
  const handleReset = () => {
    setSearchText("");
    setSelectedMonth(0);

    if (years.length > 0) {
      setSelectedYear(years[0]);
    } else {
      setSelectedYear("All");
    }
  };

  return (
    <>
      {/* Header */}
      <Header />

      {/* Page Heading / Breadcrumb */}

      {/* =========================================
          Breadcrumb Section
      ========================================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Photo"
          title2="Gallery"
          parentTitle="Gallery"
          path="Photo Gallery"
        />
      </div>

      {/* =========================================
          Inner Page Content
      ========================================= */}
      <div className="innerbody">
        <div className="container-fluid">
          {/* =========================================
              Filters
          ========================================= */}
          <div className="row tabs-dynamics mt-3">
            {/* Total Count */}
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-12 mb-2">
              <div className="filter-card count-card h-100">
                <p>
                  Total Count <span>{filteredData.length}</span>
                </p>
              </div>
            </div>

            {/* Year Filter */}
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-12 mb-2">
              <div className="filter-card h-100">
                <select
                  className="form-select filter-select"
                  value={selectedYear}
                  onChange={(e) => {
                    const value = e.target.value;

                    setSelectedYear(value === "All" ? "All" : Number(value));
                  }}
                >
                  <option value="All">All Years</option>

                  {years.map((year) => (
                    <option key={year} value={year}>
                      {`${year} - ${year + 1}`}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Month Filter */}
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-12 mb-2">
              <div className="filter-card h-100">
                <select
                  className="form-select filter-select"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(Number(e.target.value))}
                >
                  <option value={0}>All Months</option>

                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {new Date(2000, i).toLocaleString("en-US", {
                        month: "short",
                      })}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Search */}
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-12 mb-2">
              <div className="filter-card h-100">
                <input
                  type="text"
                  placeholder="Search gallery..."
                  className="form-control filter-input"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* =========================================
              Gallery Section
          ========================================= */}
          <div className="row" id="photoDetailsContainer">
            {filteredData.length > 0 ? (
              filteredData.map((item, idx) => {
                const imageUrl =
                  item.attachments && item.attachments.length > 0
                    ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                    : FALLBACK_IMAGE;

                const dateInfo = formatDate(item.date);

                return (
                  <div
                    key={item._id || idx}
                    className={`col-xl-3 col-lg-4 col-md-6 col-sm-12 gallery-item ${
                      idx >= 8 ? "hidden" : ""
                    }`}
                  >
                    <div className="gallery-inner">
                      {/* Image */}
                      <div className="gallery-blk">
                        <img
                          className="img-fluid"
                          src={imageUrl}
                          alt={item.title || "Gallery Image"}
                          onError={(e) => {
                            e.target.src = FALLBACK_IMAGE;
                          }}
                        />
                      </div>

                      {/* Content */}
                      <div className="gallery-content">
                        {/* Date */}
                        {item.date && (
                          <div className="gallery-date">
                            <span>{dateInfo.day}</span>
                            <small>{dateInfo.month}</small>
                          </div>
                        )}

                        {/* Title */}
                        <div className="gallery-title">
                          <h3>{item.title || "Gallery Title"}</h3>
                        </div>

                        {/* Number + View */}
                        <div className="gall_num_view">
                          <div className="gall-num">
                            <h6>
                              <span>Photos :</span>{" "}
                              {item.attachments?.length || 0}
                            </h6>
                          </div>

                          <a
                            href={`/subgallery/${item._id}`}
                            className="view-mores"
                          >
                            View <i className="bi bi-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-12 text-center py-5">
                <img
                  src={DUMMY_IMAGE}
                  alt="No Gallery Found"
                  className="img-fluid"
                />

                <h5 className="mt-3">No gallery found</h5>
              </div>
            )}
          </div>

          {/* =========================================
              Show More Button
          ========================================= */}
          {filteredData.length > 8 && (
            <div className="text-center mt-3">
              <button
                id="showMoreBtn"
                onClick={handleShowMore}
                className="photo-gallery reset-btn"
              >
                Show More
              </button>
            </div>
          )}

          {/* =========================================
              Reset Button
          ========================================= */}
          {(searchText || selectedMonth !== 0 || selectedYear === "All") && (
            <div className="text-center mt-3">
              <button
                type="button"
                className="photo-gallery reset-btn"
                onClick={handleReset}
              >
                Reset Filters
              </button>
            </div>
          )}
        </div>
      </div>
      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default PhotoGallery;
